import React from 'react';

function Icon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="234" height="333" version="1.1">
            <g transform="translate(0 -719.362)">
                <g>
                    <rect
                        width="233.244"
                        height="332.244"
                        x="0.378"
                        y="719.74"
                        fill="#fff"
                        fillOpacity="1"
                        stroke="gray"
                        strokeDasharray="none"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeMiterlimit="4"
                        strokeOpacity="1"
                        strokeWidth="0.756"
                        rx="8.919"
                        ry="8.946"
                    ></rect>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M12.899 780.702c0-.556-.031-.958-.031-1.514h3.545v-2.737c-2.244.072-4.673.24-6.774-.687-1.627-.893-2.076-2.97-1.748-4.68.281-1.927 1.353-3.638 2.75-4.957 1.82-1.946 4.14-3.26 6.562-4.316 2.472 1.075 4.843 2.431 6.685 4.428 1.66 1.56 2.765 3.764 2.731 6.071.036 1.665-.995 3.425-2.697 3.789-1.904.527-3.83.434-5.785.352v2.737h3.353c0 .556.03.958.03 1.514a665.864 665.864 0 00-8.621 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M212.488 991.022c0 .556-.031.958-.031 1.514h3.545v2.737c-2.244-.072-4.673-.239-6.774.687-1.627.893-2.076 2.971-1.748 4.68.28 1.927 1.352 3.639 2.75 4.957 1.82 1.946 4.14 3.26 6.562 4.316 2.472-1.075 4.843-2.431 6.685-4.428 1.66-1.56 2.765-3.763 2.731-6.07.036-1.666-.996-3.426-2.697-3.79-1.904-.527-3.83-.433-5.785-.352v-2.737h3.353c0-.556.03-.958.03-1.514-2.632.019-5.778.019-8.621 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M104.08 814.076c0-1.668-.093-2.873-.093-4.541h10.635v-8.211c-6.732.216-14.018.716-20.322-2.061-4.88-2.679-6.227-8.913-5.243-14.038.842-5.783 4.057-10.918 8.25-14.873 5.458-5.838 12.418-9.778 19.684-12.949 7.417 3.224 14.53 7.294 20.057 13.285 4.978 4.678 8.295 11.29 8.193 18.212.108 4.996-2.987 10.276-8.092 11.367-5.711 1.581-11.492 1.3-17.354 1.057v8.21h10.058c0 1.67.092 2.874.092 4.542-7.897-.055-17.336-.055-25.865 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M104.08 957.648c0 1.668-.093 2.873-.093 4.541h10.635v8.212c-6.732-.217-14.018-.717-20.322 2.06-4.88 2.679-6.227 8.913-5.243 14.039.842 5.782 4.057 10.918 8.25 14.873 5.458 5.837 12.418 9.778 19.684 12.948 7.417-3.224 14.53-7.294 20.057-13.285 4.978-4.678 8.295-11.29 8.193-18.212.108-4.996-2.987-10.276-8.092-11.366-5.711-1.582-11.492-1.301-17.354-1.057v-8.212h10.058c0-1.668.092-2.873.092-4.54-7.897.055-17.336.055-25.865 0z"
                    ></path>
                    <g
                        style={{ lineHeight: '0%' }}
                        fill="#000"
                        fillOpacity="1"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="3.772"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        transform="scale(.98105 1.01931)"
                        wordSpacing="0"
                    >
                        <path
                            style={{ lineHeight: '1.25' }}
                            strokeWidth="1"
                            d="M27 735.552l-.711 5.649H7.94q.423-4.86 3.92-8.588l6.224-5.303q3.247-2.804 3.247-5.629 0-1.882-1.076-2.997-1.056-1.133-2.92-1.133-2.152 0-3.208 1.153-.692.768-1.057 2.363-.365 1.69-.576 1.96-.308.095-.711.095h-2.42q-.424 0-.73-.173-.135-.403-.135-.903 0-4.015 2.632-6.378 2.516-2.267 6.55-2.267 3.747 0 6.13 1.998 2.536 2.113 2.536 5.802 0 3.631-2.805 6.647-.98 1.076-5.572 4.592-3.343 2.594-4.111 4.669h8.953l.153-1.73q.212-.922 1.134-.922h1.92q1.115 0 .98 1.095z"
                            fontSize="39.346"
                        ></path>
                    </g>
                    <g
                        style={{ lineHeight: '0%' }}
                        fill="#000"
                        fillOpacity="1"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="3.772"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        transform="scale(-.98105 -1.01931)"
                        wordSpacing="0"
                    >
                        <path
                            style={{ lineHeight: '1.25' }}
                            strokeWidth="1"
                            d="M-211.519-1002.606l-.71 5.648h-18.348q.422-4.86 3.919-8.588l6.225-5.302q3.246-2.805 3.246-5.63 0-1.882-1.075-2.997-1.057-1.133-2.92-1.133-2.152 0-3.21 1.153-.69.768-1.056 2.363-.365 1.69-.576 1.96-.307.095-.71.095h-2.422q-.422 0-.73-.172-.134-.404-.134-.904 0-4.015 2.632-6.378 2.517-2.267 6.551-2.267 3.746 0 6.129 1.998 2.536 2.113 2.536 5.802 0 3.631-2.805 6.647-.98 1.076-5.572 4.592-3.343 2.594-4.111 4.669h8.953l.153-1.73q.212-.922 1.134-.922h1.921q1.114 0 .98 1.095z"
                            fontSize="39.346"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default Icon;
